import api from '../utils/api';

export async function listChannelsAdmin({
  page = 1,
  perPage = 20,
  botmakerChannelId,
} = {}) {
  const params = { page, per_page: perPage };
  if (botmakerChannelId) {
    params.botmaker_channel_id = botmakerChannelId;
  }
  const { data } = await api.get('/admin/channels', { params });
  return data;
}

export async function getChannelAdmin(channelId) {
  const { data } = await api.get(`/admin/channels/${channelId}`);
  return data;
}

export async function createChannelAdmin(payload) {
  const { data } = await api.post('/admin/channels', {
    agent_id: payload.agentId,
    name: payload.name,
    type: payload.type || 'whatsapp',
    catalog_id: payload.catalogId || undefined,
    delivery_url: payload.deliveryUrl || undefined,
    delivery_token: payload.deliveryToken || undefined,
  });
  return data;
}

export async function updateChannelAdmin(channelId, payload) {
  const { data } = await api.patch(`/admin/channels/${channelId}`, {
    name: payload.name || undefined,
    delivery_url: payload.deliveryUrl || undefined,
    delivery_token: payload.deliveryToken || undefined,
  });
  return data;
}

export async function rotateChannelWebhookSecretAdmin(channelId) {
  const { data } = await api.post(`/admin/channels/${channelId}/rotate-webhook-secret`);
  return data;
}

export async function deleteChannelAdmin(channelId) {
  const { data } = await api.delete(`/admin/channels/${channelId}`);
  return data;
}
